import { useEffect, useState } from "react"
import { FaFacebook, FaGlobe, FaTelegram, FaTwitter } from "react-icons/fa"
import { useNavigate } from "react-router-dom"
import { reactLocalStorage } from "reactjs-localstorage"
import { LoaderSpinner } from "../../atoms"

const StepFour = () => {
  const [data, setData] = useState({})
  const navigate = useNavigate()
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    const formPreview = reactLocalStorage.getObject('formData')
    console.log(formPreview)    
    const newData = {
      tokenAddress : formPreview.tokenAddress,
      tokenName : formPreview.tokenName,
      decimal : formPreview.decimal,
      symbol : formPreview.symbol,
      supply : formPreview.supply,
      desc : formPreview.desc,
      tokenPresale : formPreview.tokenPresale.replace(/,/g, ''),
      tokenLiquidity : parseInt(formPreview.liquidity),
      listingOn : formPreview.listingOn,
      presaleRate : formPreview.listingPresale.replace(/,/g, ''),
      listingRate : formPreview.listingRate.replace(/,/g, ''),
      softCap : parseInt(formPreview.softCap),
      hardCap : parseInt(formPreview.hardCap),
      liquidity : formPreview.liquidity,
      minContribute : formPreview.minContribute,
      maxContribute : formPreview.maxContribute,
      startTime : formPreview.startTime,
      endTime : formPreview.endTime,
      liquidityLockupTime : parseInt(formPreview.liquidityLockupTime),
      logoList : formPreview.tokenLogo,
      twitter : formPreview.twitter,
      facebook : formPreview.facebook,
      telegram : formPreview.telegram,
      email : formPreview.email,
      listType : formPreview.listType,
    }
    setData(newData)
  }, [])

  const submitData = () => {
    const apiUrl = process.env.REACT_APP_API_URL;
    setIsLoading(true)
    // SUBMIT DATA KE DB disini
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    const raw = JSON.stringify(data)
    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    };

    fetch(`${apiUrl}/list`, requestOptions)
      .then(response => response.text())
      .then(result => {
        navigate("/")
      })
      .catch(error => console.log('error', error));

    // // CLEAR TEMP DATA
    // reactLocalStorage.remove('formData')
    // // SIMULASI LOADING
    // setTimeout(() => {
    //   setIsLoading(false)
    // }, 1000);
    // navigate('/finish')
  }

  return (
    <>
      <div className="step-info">
        <h3 className="step-title">Finalize</h3>
        <span className="desc">
          Review your information
        </span>
      </div>
      <div className="form-step">
        <div className="preview-info">
          <div className="left">
            <img src={data.tokenLogo} alt="" />
          </div>
          <div className="right">
            <div className="info-additional">
              <div className="item">
                <div className="fa"><FaGlobe /></div>
                <div className="fa"><FaFacebook /></div>
                <div className="fa"><FaTelegram /></div>
                <div className="fa"><FaTwitter /></div>
              </div>
            </div>
            <div className="input-wrapper desc">
              <input value={data.desc} type="text" className="input-token" placeholder="Description" />
            </div>
          </div>
        </div>
        <div className="input-wrapper">
          <span className="desc">
            Token Address:
          </span>
          <input value={data.tokenAddress} type="text" className="input-token" placeholder="Token Address" />
        </div>
        <div className="input-wrapper">
          <span className="desc">
            Token Symbol:
          </span>
          <input value={data.symbol} type="text" className="input-token" placeholder="Token Symbol" />
        </div>
        <div className="input-wrapper">
          <span className="desc">
            Token Decimals:
          </span>
          <input value={data.decimal} type="text" className="input-token" placeholder="Token Decimals" />
        </div>
        <div className="input-wrapper">
          <span className="desc">
            Total Supply:
          </span>
          <input value={data.supply} type="text" className="input-token" placeholder="Total Supply" />
        </div>
        <div className="input-wrapper">
          <span className="desc">
            Token For Presale:
          </span>
          <input value={data.listingRate} type="text" className="input-token" placeholder="Token For Presale" />
        </div>
        <div className="input-wrapper">
          <span className="desc">
            Token For Liquidity:
          </span>
          <input value={data.tokenLiquidity} type="text" className="input-token" placeholder="Token For Liquidity" />
        </div>
        <div className="input-wrapper">
          <span className="desc">
            Presale Rate [per BNB]:
          </span>
          <input value={data.listingRate} type="text" className="input-token" placeholder="Presale Rate" />
        </div>
        <div className="input-wrapper">
          <span className="desc">
            Listing Rate [per BNB]:
          </span>
          <input value={data.listingPresale} type="text" className="input-token" placeholder="Listing Rate" />
        </div>
        <div className="input-wrapper">
          <span className="desc">
            Soft Cap [BNB]:
          </span>
          <input value={data.softCap} type="text" className="input-token" placeholder="Soft Cap" />
        </div>
        <div className="input-wrapper">
          <span className="desc">
            Hard Cap [BNB]:
          </span>
          <input value={data.hardCap} type="text" className="input-token" placeholder="Hard Cap" />
        </div>
        <div className="input-wrapper">
          <span className="desc">
            Presale Start Time:
          </span>
          <input value={Date(data.startTime)} type="text" className="input-token" placeholder="Presale Start Time" />
        </div>
        <div className="input-wrapper">
          <span className="desc">
            Presale End Time:
          </span>
          <input value={Date(data.endTime)} type="text" className="input-token" placeholder="Presale End Time" />
        </div>
        <div className="input-wrapper">
          <span className="desc">
            Listing On:
          </span>
          <input value={data.listingOn} type="text" className="input-token" placeholder="Listing On" />
        </div>
        <div className="input-wrapper">
          <span className="desc">
            Liquidity [%]:
          </span>
          <input value={data.liquidity} type="text" className="input-token" placeholder="Liquidity Percent" />
        </div>
        <div className="input-wrapper">
          <span className="desc">
            Liquidity Lockup Time [days]:
          </span>
          <input value={data.liquidityLockupTime} type="text" className="input-token" placeholder="Liquidity Lockup Time" />
        </div>
      </div>
      <div className="action-next">
        <button onClick={submitData} className="next-link">FINISH</button>
        {/* <Link className="next-link" to="/finish">FINISH</Link> */}
      </div>
      {
        isLoading && <LoaderSpinner />
      }
    </>
  )
}

export default StepFour
